export default __webpack_public_path__ + "static/media/brandmark1.41b8f71c.png";